<loading *ngIf="loading">
  <ng-container i18n="@@front.verifyIp.loading">Verifing your IP address</ng-container>
</loading>

<error *ngIf="error">
  {{error}}
</error>

<div class="p-2 text-center">
  <a routerLink="/login" class="btn btn-primary" i18n="@@front.verifyIp.loginButton">Login again</a>
</div>